import { t } from '../../common/i18n.js'
import { NotificationListProps } from '../components/notification-list/notification-list.js'
import { NotificationContainerProps } from '../components/notification/notification-container.js'
import { NotificationData, NotificationProps } from '../components/notification/notification.js'
import { View } from '../types.js'
import { closeNotification } from '../utils/notification-utils.js'

export const getNotificationProps = (view: View): NotificationContainerProps => {
    const { state } = view
    const closeLabel = t.common.closeNotification(state.lang)

    const notifications: NotificationData[] = state.notifications
        .filter((notification): notification is typeof notification => !notification.closedAt)
        .map(
            (notification): NotificationData => ({
                id: notification.id,
                variant: notification.type,
                title: notification.text,
                message: notification.additionalText,
            }),
        )

    return {
        notifications,
        closeLabel,
        onClose: (id: string) => {
            const notification = state.notifications.find((n) => n.id === id)
            if (notification) {
                closeNotification(view, notification)
            }
        },
    }
}

export const getNotificationListProps = (view: View): NotificationListProps => {
    const { state } = view
    const closeLabel = t.common.closeNotification(state.lang)

    const items: NotificationProps[] = state.notifications
        .filter((notification): notification is typeof notification => !notification.closedAt)
        .map(
            (notification): NotificationProps => ({
                id: notification.id,
                variant: notification.type,
                title: notification.text,
                message: notification.additionalText,
                onClose: () => closeNotification(view, notification),
                closeLabel,
            }),
        )

    return { items }
}
